/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetUserContactsForUnionResponseDto { 
    id?: string;
    contactTypeId?: number;
    contact?: string;
    description?: string;
    sortOrder?: number;
    isRequired?: boolean;
    customListId?: string;
    customListValueId?: string;
}

